// 🚨 AUTO-GENERADO desde ExpenseDataType.ts - No editar manualmente

export const ExpenseFormDataKeys = [
  "id",
  "sequence",
  "document_key",
  "fecha",
  "nombre",
  "identificacion",
  "subtotal",
  "impuestos",
  "descuento",
  "monto",
  "detalle",
  "exchange_rate",
  "excluir_reporte",
  "expenseCategoryId",
  "expenseCategory",
  "currencyId",
  "currency",
  "expenseNotes",
  "user",
  "reference_number"
] as const;
